import axios from 'axios';
import config from '../config/config';
import {
    ADD_LOCATION_OPEN,
    ADD_LOCATION_PREPARE_REQUEST,
    ADD_LOCATION_PREPARE_RECEIVE,
    ADD_LOCATION_SAVE_REQUEST,
    ADD_LOCATION_SAVE_RECEIVE,
    ADD_LOCATION_SAVE_RECEIVE_ERROR,
    ADD_LOCATION_CANCEL,
    ADD_LOCATION_CHANGE_VALUE
} from "../config/actions";
import {getSchedule} from './scheduleAction';

export function openDialog() {
    return dispatch => {
        dispatch(prepare());
        dispatch({
            type: ADD_LOCATION_OPEN
        });
    }
}

export function prepare() {
    return dispatch => {
        dispatch({type: ADD_LOCATION_PREPARE_REQUEST});
        axios(config.server.endpoint + 'backend/location/availableLocationGroupsAndWorkTypes', {
            method: 'get'
        }).then((response) => {
            dispatch({
                type: ADD_LOCATION_PREPARE_RECEIVE,
                data: response.data
            });
        })
    }
}

export function cancel() {
    return {
        type: ADD_LOCATION_CANCEL
    }
}

export function changeValue(name, value) {
    return {
        type: ADD_LOCATION_CHANGE_VALUE,
        name: name,
        value: value
    }
}

export function save(data) {
    return dispatch => {
        dispatch({
            type: ADD_LOCATION_SAVE_REQUEST
        });
        axios(config.server.endpoint + 'backend/location/', {
            method: 'post',
            data: {
                name: data.name,
                groupName: data.groupName,
                workType: data.workType
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch(getSchedule());
                    dispatch({
                        type: ADD_LOCATION_SAVE_RECEIVE
                    });
                } else {
                    dispatch({
                        type: ADD_LOCATION_SAVE_RECEIVE_ERROR,
                        data: response.data
                    });
                }
            }
        });
    }
}
